export default {"src":"/_next/static/media/0xf4eb217ba2454613b15dbdea6e5f22276410e89e.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};